import React, { FC } from "react";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

import Logo from "assets/images/iban_oplata-logo.svg";

import { blogURL } from "routes/blogRoutes";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface FooterSection {
  title: string;
  link: string;
  event: string;
}

const footerSections: Array<FooterSection> = [
  {
    title: "Політика конфіденційності",
    link: "/terms-of-service",
    event: "terms_of_service",
  },
  { title: "Публічна оферта", link: "/public-offer", event: "public_offer" },
  {
    title: "Viber та Telegram: +380980965020",
    link: "tel:+380980965020",
    event: "viber_telegram",
  },
  {
    title: "E-mail: info@ibanoplata.com",
    link: "mailto:info@ibanoplata.com",
    event: "email",
  },
];

const WebsiteFooter: FC = () => {
  const onLinkClick = (event: string) => {
    analytics().sendEvent(AnalyticsEvents.footer_ + event);
  };

  return (
    <Box component="footer" sx={{ backgroundColor: "#202331" }}>
      <Container
        sx={({ breakpoints }) => ({
          pt: 2,
          pb: 2,
          display: "flex",
          flexDirection: "column",
          [breakpoints.up("md")]: {
            alignItems: "center",
            flexDirection: "row",
          },
        })}
      >
        <Box
          component="img"
          width={40}
          height={40}
          mr={4}
          alt="Logo"
          src={Logo}
        />
        <Box component="ul" sx={{ display: { md: "flex" } }}>
          <Box component="li" key={"Блог"} mt={{ xs: 2, md: 0 }}>
            <Link
              href={blogURL}
              onClick={(_) => {
                onLinkClick("blog");
              }}
              underline="none"
              color="white"
              mr={2}
            >
              Блог
            </Link>
          </Box>
          {footerSections.map(({ title, link, event }) => (
            <Box component="li" key={title} mt={{ xs: 2, md: 0 }}>
              <Link
                href={link}
                onClick={(_) => {
                  onLinkClick(event);
                }}
                underline="none"
                color="white"
                mr={2}
              >
                {title}
              </Link>
            </Box>
          ))}
        </Box>
        <Box
          component="span"
          ml={{ xs: 0, md: "auto" }}
          mt={{ xs: 2, md: 0 }}
          color="white"
        >
          © ТзОВ &quot;ФОПкаса&quot; {new Date().getFullYear()}
        </Box>
      </Container>
    </Box>
  );
};

export default WebsiteFooter;
